import { IOSNOLOGINSTATUS } from "views/components/LTReceiveToast";
import { SuccessCode } from "views/mobile/components/MCouponCode";
import { LinkTargetType } from "views/services/playground";
import { GetReceiveCouponResp } from "./zeusFetch";

interface JumpToLoginProps {
	isMobile: boolean;
	isInApp: boolean;
	isUat: boolean;
	aTarget?: LinkTargetType;
}

export const jumpToLogin = ({
	isMobile = false,
	isInApp = false,
	isUat = true,
}: // aTarget = LinkTargetType.Blank,
JumpToLoginProps): Promise<GetReceiveCouponResp> => {
	if (isInApp) {
		customizeAppLogin();
		return Promise.resolve({
			code: SuccessCode,
			error_msg: [],
			extInfo: [],
			result: "",
			info: {
				status: IOSNOLOGINSTATUS, // 自定义状态码 IOS 未登录
			},
		});
	}
	if (isUat) {
		if (isMobile) {
			location.replace("https://gmqa1-a.lightinthebox.tbox.me/en/signin");
		} else {
			location.replace("https://w1.tbox.me/index.php?main_page=login");
		}
	} else {
		location.replace(
			`https://gw.lightinthebox.com/index.php?main_page=login&targetUrl=${location?.href}`,
		);
	}

	return Promise.resolve({
		code: "",
		info: {
			status: 0,
		},
	} as GetReceiveCouponResp);
};

function customizeAppLogin() {
	const element = document.createElement("a");
	element.setAttribute("href", "litb://login");
	// element.setAttribute("target", "_self");
	element.style.display = "none";
	document.body.appendChild(element);
	element.click();
	if (document.body.contains(element)) {
		document.body.removeChild(element);
	}
}
